/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EventType = {
    attendee_merged: 'attendee.merged',
    program_attendee_merged: 'program_attendee.merged',
    program_attendee_complete_merged: 'program_attendee.complete_merged',
    membership_merged_attendee: 'membership.merged_attendee',
    registration_merged_attendee: 'registration.merged_attendee',
    session_credit_merged_attendee: 'session_credit.merged_attendee',
    activity_merged_attendee: 'activity.merged_attendee',
    note_merged_attendee: 'note.merged_attendee',
    feedback_merged_attendee: 'feedback.merged_attendee',
    campaign_created: 'campaign.created',
    campaign_updated: 'campaign.updated',
    campaign_deleted: 'campaign.deleted',
    conversation_updated: 'conversation.updated',
    conversation_mark_open: 'conversation.mark_open',
    conversation_bulk_updated: 'conversation.bulk_updated',
    conversation_bulk_mark_open: 'conversation.bulk_mark_open',
    conversation_mark_closed: 'conversation.mark_closed',
    conversation_bulk_mark_closed: 'conversation.bulk_mark_closed',
    conversation_archive: 'conversation.archive',
    conversation_bulk_archive: 'conversation.bulk_archive',
    message_analytics_updated: 'message.analytics_updated',
    message_created: 'message.created',
    message_sent: 'message.sent',
    message_bulk_created: 'message.bulk_created',
    message_bulk_sent: 'message.bulk_sent',
    message_tracked: 'message.tracked',
    message_received: 'message.received',
    message_updated: 'message.updated',
    message_bounced: 'message.bounced',
    message_complained: 'message.complained',
    message_delivered: 'message.delivered',
    program_phone_number_created: 'program_phone_number.created',
    program_phone_number_updated: 'program_phone_number.updated',
    program_phone_number_deleted: 'program_phone_number.deleted',
    short_link_created: 'short_link.created',
    short_link_clicked: 'short_link.clicked',
    short_link_deleted: 'short_link.deleted',
    short_link_updated: 'short_link.updated',
    attendee_created: 'attendee.created',
    attendee_updated: 'attendee.updated',
    attendee_deleted: 'attendee.deleted',
    customer_created: 'customer.created',
    customer_updated: 'customer.updated',
    customer_deleted: 'customer.deleted',
    contact_created: 'contact.created',
    contact_updated: 'contact.updated',
    contact_invited: 'contact.invited',
    contact_joined: 'contact.joined',
    contact_subscribed: 'contact.subscribed',
    contact_unsubscribed: 'contact.unsubscribed',
    contact_deleted: 'contact.deleted',
    contact_bulk_created: 'contact.bulk_created',
    contact_account_balance_created: 'contact.account_balance_created',
    contact_account_balance_updated: 'contact.account_balance_updated',
    program_attendee_created: 'program_attendee.created',
    program_attendee_joined: 'program_attendee.joined',
    program_attendee_updated: 'program_attendee.updated',
    program_attendee_disconnected: 'program_attendee.disconnected',
    program_attendee_bulk_created: 'program_attendee.bulk_created',
    program_attendee_viewed_health_card: 'program_attendee.viewed_health_card',
    order_dispute_closed: 'order.dispute.closed',
    order_dispute_created: 'order.dispute.created',
    order_dispute_funds_reinstated: 'order.dispute.funds_reinstated',
    order_dispute_funds_withdrawn: 'order.dispute.funds_withdrawn',
    order_dispute_updated: 'order.dispute.updated',
    feedback_bulk_created: 'feedback.bulk_created',
    feedback_created: 'feedback.created',
    feedback_updated: 'feedback.updated',
    feedback_submitted: 'feedback.submitted',
    file_created: 'file.created',
    file_deleted: 'file.deleted',
    attachment_created: 'attachment.created',
    attachment_deleted: 'attachment.deleted',
    coupon_created: 'coupon.created',
    coupon_deleted: 'coupon.deleted',
    coupon_updated: 'coupon.updated',
    discount_bulk_created: 'discount.bulk_created',
    discount_created: 'discount.created',
    discount_deleted: 'discount.deleted',
    discount_updated: 'discount.updated',
    order_item_bulk_created: 'order_item.bulk_created',
    order_item_created: 'order_item.created',
    order_item_deleted: 'order_item.deleted',
    order_item_updated: 'order_item.updated',
    order_bulk_created: 'order.bulk_created',
    order_bulk_processed: 'order.bulk_processed',
    order_bulk_updated: 'order.bulk_updated',
    order_created: 'order.created',
    order_deleted: 'order.deleted',
    order_email_requested: 'order.email_requested',
    order_processed: 'order.processed',
    order_refunded: 'order.refunded',
    order_updated: 'order.updated',
    product_category_created: 'product_category.created',
    product_category_deleted: 'product_category.deleted',
    product_category_updated: 'product_category.updated',
    product_variation_created: 'product_variation.created',
    product_variation_deleted: 'product_variation.deleted',
    product_variation_updated: 'product_variation.updated',
    product_created: 'product.created',
    product_deleted: 'product.deleted',
    product_updated: 'product.updated',
    promotion_created: 'promotion.created',
    promotion_deleted: 'promotion.deleted',
    promotion_updated: 'promotion.updated',
    refund_created: 'refund.created',
    refund_updated: 'refund.updated',
    tax_rates_created: 'tax_rates.created',
    tax_rates_deleted: 'tax_rates.deleted',
    tax_rates_updated: 'tax_rates.updated',
    terminal_created: 'terminal.created',
    terminal_deleted: 'terminal.deleted',
    terminal_requested: 'terminal.requested',
    terminal_updated: 'terminal.updated',
    note_created: 'note.created',
    note_deleted: 'note.deleted',
    invite_created: 'invite.created',
    invite_bulk_created: 'invite.bulk_created',
    invite_accepted: 'invite.accepted',
    invite_deleted: 'invite.deleted',
    member_created: 'member.created',
    member_updated: 'member.updated',
    member_deleted: 'member.deleted',
    program_created: 'program.created',
    program_updated: 'program.updated',
    payout_settings_started: 'payout_settings.started',
    payout_settings_completed: 'payout_settings.completed',
    program_insights_created: 'program_insights.created',
    program_referral_created: 'program_referral.created',
    program_referral_completed: 'program_referral.completed',
    scheduled_tasks_campaign_send_completed: 'scheduled_tasks.campaign_send_completed',
    scheduled_tasks_campaign_send_invoked: 'scheduled_tasks.campaign_send_invoked',
    scheduled_tasks_canceled_memberships_completed: 'scheduled_tasks.canceled_memberships_completed',
    scheduled_tasks_canceled_memberships_invoked: 'scheduled_tasks.canceled_memberships_invoked',
    scheduled_tasks_daily_insights_completed: 'scheduled_tasks.daily_insights_completed',
    scheduled_tasks_daily_insights_invoked: 'scheduled_tasks.daily_insights_invoked',
    scheduled_tasks_due_memberships_completed: 'scheduled_tasks.due_memberships_completed',
    scheduled_tasks_due_memberships_invoked: 'scheduled_tasks.due_memberships_invoked',
    scheduled_tasks_feedback_create_completed: 'scheduled_tasks.feedback_create_completed',
    scheduled_tasks_feedback_create_invoked: 'scheduled_tasks.feedback_create_invoked',
    scheduled_tasks_monthly_insights_completed: 'scheduled_tasks.monthly_insights_completed',
    scheduled_tasks_monthly_insights_invoked: 'scheduled_tasks.monthly_insights_invoked',
    scheduled_tasks_order_item_product_sync_completed: 'scheduled_tasks.order_item_product_sync_completed',
    scheduled_tasks_order_item_product_sync_invoked: 'scheduled_tasks.order_item_product_sync_invoked',
    scheduled_tasks_membership_package_product_sync_invoked: 'scheduled_tasks.membership_package_product_sync_invoked',
    scheduled_tasks_session_package_product_sync_invoked: 'scheduled_tasks.session_package_product_sync_invoked',
    scheduled_tasks_program_event_product_sync_invoked: 'scheduled_tasks.program_event_product_sync_invoked',
    scheduled_tasks_registration_option_product_sync_invoked: 'scheduled_tasks.registration_option_product_sync_invoked',
    scheduled_tasks_appointment_type_product_sync_invoked: 'scheduled_tasks.appointment_type_product_sync_invoked',
    scheduled_tasks_appointment_option_product_sync_invoked: 'scheduled_tasks.appointment_option_product_sync_invoked',
    scheduled_tasks_past_due_memberships_completed: 'scheduled_tasks.past_due_memberships_completed',
    scheduled_tasks_past_due_memberships_invoked: 'scheduled_tasks.past_due_memberships_invoked',
    scheduled_tasks_product_sync_completed: 'scheduled_tasks.product_sync_completed',
    scheduled_tasks_product_sync_invoked: 'scheduled_tasks.product_sync_invoked',
    scheduled_tasks_program_attendee_sync_completed: 'scheduled_tasks.program_attendee_sync_completed',
    scheduled_tasks_program_attendee_sync_invoked: 'scheduled_tasks.program_attendee_sync_invoked',
    scheduled_tasks_program_event_sync_completed: 'scheduled_tasks.program_event_sync_completed',
    scheduled_tasks_program_event_sync_invoked: 'scheduled_tasks.program_event_sync_invoked',
    scheduled_tasks_program_insights_created: 'scheduled_tasks.program_insights_created',
    scheduled_tasks_scheduled_memberships_completed: 'scheduled_tasks.scheduled_memberships_completed',
    scheduled_tasks_scheduled_memberships_invoked: 'scheduled_tasks.scheduled_memberships_invoked',
    scheduled_tasks_weekly_insights_completed: 'scheduled_tasks.weekly_insights_completed',
    scheduled_tasks_weekly_insights_invoked: 'scheduled_tasks.weekly_insights_invoked',
    membership_package_created: 'membership_package.created',
    membership_package_deleted: 'membership_package.deleted',
    membership_package_updated: 'membership_package.updated',
    membership_package_discontinued: 'membership_package.discontinued',
    membership_canceled: 'membership.canceled',
    membership_created: 'membership.created',
    membership_updated: 'membership.updated',
    membership_bulk_canceled: 'membership.bulk_canceled',
    membership_bulk_updated: 'membership.bulk_updated',
    program_event_cancelled: 'program_event.cancelled',
    program_event_created: 'program_event.created',
    program_event_deleted: 'program_event.deleted',
    program_event_published: 'program_event.published',
    program_event_bulk_created: 'program_event.bulk_created',
    program_event_bulk_published: 'program_event.bulk_published',
    program_event_bulk_updated: 'program_event.bulk_updated',
    program_event_bulk_cancelled: 'program_event.bulk_cancelled',
    program_event_bulk_deleted: 'program_event.bulk_deleted',
    program_event_updated: 'program_event.updated',
    quick_filter_created: 'quick_filter.created',
    quick_filter_deleted: 'quick_filter.deleted',
    quick_filter_updated: 'quick_filter.updated',
    registration_created: 'registration.created',
    registration_deleted: 'registration.deleted',
    registration_updated: 'registration.updated',
    registration_transferred: 'registration.transferred',
    registration_bulk_created: 'registration.bulk_created',
    registration_cancelled: 'registration.cancelled',
    registration_option_created: 'registration_option.created',
    registration_option_updated: 'registration_option.updated',
    registration_option_bulk_updated: 'registration_option.bulk_updated',
    registration_option_deleted: 'registration_option.deleted',
    program_event_venue_created: 'program_event_venue.created',
    program_event_venue_updated: 'program_event_venue.updated',
    program_event_venue_deleted: 'program_event_venue.deleted',
    venue_created: 'venue.created',
    venue_updated: 'venue.updated',
    venue_deleted: 'venue.deleted',
    appointment_created: 'appointment.created',
    appointment_updated: 'appointment.updated',
    appointment_canceled: 'appointment.canceled',
    appointment_option_created: 'appointment_option.created',
    appointment_option_deleted: 'appointment_option.deleted',
    appointment_option_updated: 'appointment_option.updated',
    appointment_type_created: 'appointment_type.created',
    appointment_type_updated: 'appointment_type.updated',
    appointment_type_published: 'appointment_type.published',
    appointment_type_deleted: 'appointment_type.deleted',
    session_credit_created: 'session_credit.created',
    session_credit_deleted: 'session_credit.deleted',
    session_credit_updated: 'session_credit.updated',
    session_credit_bulk_updated: 'session_credit.bulk_updated',
    session_package_created: 'session_package.created',
    session_package_deleted: 'session_package.deleted',
    session_package_updated: 'session_package.updated',
    session_package_discontinued: 'session_package.discontinued',
    refund_policy_updated: 'refund_policy.updated',
    user_created: 'user.created',
    user_updated: 'user.updated',
    user_email_verified: 'user.email_verified'
} as const;
export type EventType = typeof EventType[keyof typeof EventType];


export function EventTypeFromJSON(json: any): EventType {
    return EventTypeFromJSONTyped(json, false);
}

export function EventTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventType {
    return json as EventType;
}

export function EventTypeToJSON(value?: EventType | null): any {
    return value as any;
}

